import React from "react";
import * as styles from "./autocomplete.scss";
import { searchPageUrl } from "Shared/known-urls";
import { urlToString } from "Shared/url";
import connect from "Shared/connect";
import { translate } from "Shared/translate";
class PopularSearches extends React.PureComponent {
    render() {
        const initial = !!this.props.quickSearch.completionsLists.filter((x) => x.id === "popular")[0] &&
            !!this.props.quickSearch.completionsLists.filter((x) => x.id === "popular")[0].items &&
            this.props.quickSearch.completionsLists.filter((x) => x.id === "popular")[0].items;
        const popular = !!this.props.quickSearch.completionsLists.filter((x) => x.id === "suggestions")[0] &&
            !!this.props.quickSearch.completionsLists.filter((x) => x.id === "suggestions")[0].popularSearches &&
            this.props.quickSearch.completionsLists.filter((x) => x.id === "suggestions")[0].popularSearches;
        const items = !!popular ? popular : !!initial && initial;
        return (!!items &&
            items.length > 0 && (React.createElement("div", { "data-opti-id": "quicksearch-popular-searches", className: styles.searchSuggestionBox },
            React.createElement("h4", { className: styles.h4 }, translate("/QuickSearch/PopularSearches")),
            React.createElement("ul", { key: "Popular" }, items.map((item, j) => {
                return (React.createElement("li", { key: item.text + j },
                    React.createElement("a", { href: urlToString({
                            path: searchPageUrl().url,
                            query: { q: item.text },
                        }), "data-ticket": item.ticket, className: styles.button, onClick: () => this.props.onItemClick(item.text) }, item.text)));
            })))));
    }
}
export default connect((state) => ({
    quickSearch: state.quickSearch,
}))(PopularSearches);
